import React, {Component} from 'react';
import PropTypes from "prop-types";
import OrderDetailView from './OrderDetailView';
import {translate} from "react-i18next";
import Moment from 'react-moment';
import {TIME_FORMAT_ORDER} from '../../../constants';


class OrderView extends Component {

  render() {
    const {list, t, language, ingredients, refFirstOrder} = this.props;
    return (
      <div className='order__wrapper'>
        <table className='order__list' ref={refFirstOrder}>
          <thead>
          <tr>
            <th>{t('date')}</th>
            <th>{t('detail')}</th>
            <th>{t('Amount and payment')}</th>
            {/*<th>{t('payment')}</th>*/}
          </tr>
          </thead>
          <tbody>
          {list.length > 0 ? list.map((obj, index) => (
            <tr key={obj.id}>
              <td className="order__date">
                <Moment format={TIME_FORMAT_ORDER}>{obj.datetime}</Moment>
              </td>
              <td className="order__detail-cell">
                <OrderDetailView
                  data={obj.detail}
                  language={language}
                  ingredients={ingredients}
                />
              </td>
              <td className="order__price-cell">
                <div>
                  {t('amount')}: <strong className="order__price">{obj.amount} €</strong>
                </div>
                <div>
                  {t('payment')}: <strong>{t(obj.payment)}</strong>
                </div>
              </td>
            </tr>
            ))
            : <tr>
              <td colSpan={3}>
                {t('no_orders')}
              </td>
            </tr>}
          </tbody>
        </table>
      </div>
    );
  }
}

OrderView.propTypes = {
  list: PropTypes.array,
  language: PropTypes.string,
  ingredients: PropTypes.array
};

export default translate('translations')(OrderView);



// WEBPACK FOOTER //
// ./src/components/Customer/Order/OrderView.js